(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.var.show.customer.show.project.roundsReportV2', {
      url: '/rounds-report-v2',
      template: `<new-front-container path="'rounds-report'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.RoundsReportV2" | translate}}',
      },
    });
  }
})();
